import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { deDateFormat, enDateFormat } from '../utils/date-formats';

@Pipe({ name: 'dateWithLocale' })
export class DateWithLocalePipe implements PipeTransform {
  transform(value: string, language: string): string {
    let pattern: string;
    let locale: string;

    switch (language) {
      case 'de':
        locale = 'de-DE';
        pattern = deDateFormat;
        break;

      case 'en':
        locale = 'en-GB';
        pattern = enDateFormat;
        break;
    }

    return formatDate(value, pattern, locale);
  }
}
